import React, { Fragment } from 'react';
import Footer from '../../components/Footer/Footer';

const ComponentWithoutHeader = ({ component: Component, ...rest }) => {
  return (
    <Fragment>
      <div style={{ minHeight: '97vh' }} >
        <Component {...rest} />
      </div>
      <Footer></Footer>
    </Fragment>
  )
}

export default ComponentWithoutHeader;